<template>
  <div class="auction-info">
    <!-- 询价撮合车辆信息不显示起拍价 ，通过 show-price来控制。false不显示。默认为true-->
    <car-info-head
      :car-images="car.auction_car.images"
      :car-info="car.auction_car.car_info"
      :start-price="car.auction?car.auction.minimum_price:0"
      :quote-increment="car.auction?car.auction.quote_increment:0"
      :show-price="from === 'auctionMatch'"
      @click-swiper="clickSwiper">
    >
    </car-info-head>
    <images-previewer :list="car.auction_car.images" ref="previewer" :options="options" :w='600' :h='400'></images-previewer>
    <!-- 待车商确认、待付款、已成交、 || 已拒绝、已关闭 -->
    <group
      gutter="0"
      class="group-no-before"
      :class="car.auction_match.status_code === 'pending_payment' || car.auction_match.status_code === 'completed' ? 'v-auction-success' : 'v-auction-disable'"
    >
      <cell class="cell-no-before">
        <span slot="icon" class="fc-gray">撮合价 </span>
        <div slot="value">
          <x-button mini>{{car.auction_match.status_code | showStatus}}</x-button>
        </div>
        <div slot="after-title">
          <span class="fs40 fc-ce3b28">{{(car.auction_match.match_price / 100).toFixed(2)}}</span><em class="fc-red"></em>元
        </div>
      </cell>
      <cell
        class="v-cell-box v-cell-common"
        :inline-desc="`撮合车商：${car.auction_match.match_dealer_name} ${car.auction_match.match_dealer_mobile} ${car.auction_match.match_dealer_city}`"
      >
        <div slot="after-title" class="end-time fc-gray">
          <span v-if="car.auction_match.status_code === 'rejected'">车商在{{car.auction_match.user_operated_at}}取消撮合交易</span>
          <span v-else-if="car.auction_match.status_code === 'created'">车商需在{{car.auction_match.started_at | getTime}}前接受撮合交易</span>
          <span v-else>车商在{{car.auction_match.user_operated_at}}接受{{matchSource[from]}}撮合</span>
        </div>
      </cell>
    </group>
    <!-- 车辆相关信息 -->
    <car-config
      :car-info="car.auction_car.car_info"
      :car="car"
      :from="from"
    >
    </car-config>
  </div>
</template>
<script>
import util from '../../common/util'
import ImagesPreviewer from '@lx-frontend/images-previewer'
// 详情页
import {
  Cell,
  XButton,
  Group
  // Previewer
} from '@lx-frontend/cvux'
  // 引入自定义组件
import CarInfoHead from './components/CarInfoHead'
import CarConfig from './components/CarConfig'
export default {
  components: {
    Cell,
    XButton,
    Group,
    // Previewer,
    ImagesPreviewer,
    CarInfoHead,
    CarConfig
  },
  data() {
    return {
      options: {
        getThumbBoundsFn (index) {
          let isServer = typeof window === 'undefined'
          if (isServer) return
          // find thumbnail element
          let thumbnail = document.querySelectorAll('.vux-img')[index]
          // get window scroll Y
          let pageYScroll = window.pageYOffset || document.documentElement.scrollTop
          // optionally get horizontal scroll
          // get position of element relative to viewport
          let rect = thumbnail.getBoundingClientRect()
          // w = width
          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width }
          // Good guide on how to get element coordinates:
          // http://javascript.info/tutorial/coordinates
        }
      },
      car: {
        auction: {},
        auction_car: {
          images: [],
          car_info: {}
        },
        auction_match: {},
        store: {
          name: ''
        }
      }, // 车辆详情
      from: '',
      matchSource: {
        auctionMatch: '流拍',
        enquiryMatch: '询价'
      }
    }
  },
  created() {
    // 通过 from 区别是  auctionMatch 表示流拍撮合车辆详情  enquiryMatch 表示询价撮合车辆详情
    this.from = this.$route.query.from
    this.initPage()
  },
  methods: {
    clickSwiper(item) {
      this.$refs.previewer.show(item)
    },
    render(arr = []) {
      arr.map((v, i) => {
        let img = new window.Image()
        img.src = v.src
        // 如果图片被缓存，则直接返回缓存数据
        if (img.complete) {
          v.w = img.width
          v.h = img.height
          this.imgCount++
        } else {
          // 完全加载完毕的事件
          img.onload = () => {
            v.w = img.width
            v.h = img.height
            this.imgCount++
          }
        }
      })
      return arr
    },
    initPage () {
      // 撮合ID
      let auctionId = this.id = this.$route.params.id
      if (auctionId) {
        // 需要判断是流拍还是询价撮合动态调用方法。
        // from为： auctionMatch 表示流拍撮合车辆详情  enquiryMatch 表示询价撮合车辆详情
        let postMethod = ''
        let postLink = ''
        if (this.from === 'enquiryMatch') {
          postMethod = 'getEnquiryCarDetail'
          postLink = `${auctionId}/match_car_details`
        } else if (this.from === 'auctionMatch') {
          postMethod = 'getMatchCarDetail'
          postLink = auctionId
        }
        // 动态方法和请求地址
        this.$rest.match[postMethod](null, postLink).then((res) => {
          if (res.code === 0) {
            // 询价撮合和流拍撮合 enquiry_match 与 auction_match对象  不一致。所以不能直接赋值
            let infoData = res.data
            let images = infoData.auction_car.images
            if (images.length > 0) {
              images.forEach((item, index) => {
                images[index].src = item.image_url
              })
              this.car.auction_car = this.render(images)
            }
            if (this.from === 'enquiryMatch') {
              // 共用同一个对象,只不过数据来自于询价撮合对象enquiry_match
              infoData.auction_match = infoData.enquiry_match
            }
            this.car = infoData
          } else {
            this.showToast(res.message)
          }
        })
      }
    },
    changeImagesIndex (index) {
      this.imageIndex = index
    }
  },
  watch: {
    '$route' () {
      this.initPage()
    },
    car (val) {
      const title = '订单收款确认'
      const carInfo = val.auction_car.car_info
      const images = val.auction_car.images
      const desc = `${carInfo.car_model_name} ${carInfo.plate_number}`
      const imgUrl = images && images[0].image_url
      this.shareFriend({
        title,
        desc,
        imgUrl
      })
    }
  },
  filters: {
    showStatus(statusCode) {
      let result = ''
      switch (statusCode) {
        case 'created':
          result = '待车商确认'
          break
        case 'pending_payment':
          result = '待收款'
          break
        case 'completed':
          result = '已成交'
          break
        case 'closed':
          result = '已关闭'
          break
        case 'rejected':
          result = '已拒绝'
          break
        default:
          result = '未知'
      }
      return result
    },
    getTime(time) {
      let str = new Date(time.replace(/-/g, '/')).getTime() + 7200000
      return util.formatTime(new Date(str), 'yyyy-MM-dd hh:mm:ss')
    }
  }
}
</script>
<style lang="less">
@import '../../stylesheets/base/fn';
  .auction-info {
    .vux-no-group-title {
      margin-top:0;
    }
    .weui_cell_ft {
      text-align: right;
    }
    .icon-img{
      display: inline-block;
      width: 18px;
      vertical-align: middle;
    }
    .vux-flexbox.title, .weui_cell_bd.weui_cell_primary {
      // padding-top: 40/@w2;
      font-size: 30/@w2;
    }
    .fs26 .weui_cell_hd span {
      margin-right: 30/@w;
      font-size: 30/@w2;
    }
    .flexbox {
      align-items: flex-start;
      line-height: 60/@w2;
      padding-bottom: 20/@w2;
      .title {
        font-size: 30/@w2;
      }
      .key {
        color: #9a9a9a;
        font-size: 26/@w2;
        line-height: 1.4;
      }
      .value {
        font-size: 26/@w2;
        line-height: 1.4;
      }
    }
    .weui_cell.title {
      padding: 56/@w2 0.4rem 30/@w2;
    }
  }

  .auction-info {
    .weui_cells:after{ display: none}
    .txt-bottom {
      padding-top: 156/@w2;
    }
    .txt-fix {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      color: #9a9a9a;
      line-height: 44/@w2;
      text-align: center;
      font-size: 26/@w2;
      background: #eeedee;
      padding: 14/@w2 30/@w2;
    }
    .weui_cells {
      font-size: 26/@w2;
    }
    .num {
      background: #ce3b28;
      width: 40/@w2;
      height: 50/@w2;
      line-height: 50/@w2;
      color: #fff;
      font-size: 30/@w2;
      display: inline-block;
      .radius(8/@w2);
      margin: 0 3/@w2;
      text-align: center;
    }
    .no-surpass-price .num {
      background: #a7a7b1;
    }
    .swiper-car1 {
      position: relative;
    }
    .swiper-car2 {
      background: #fff;
    }
    .v-cell-box {
      background: #f0f0f0;
      padding: 30/@w2;
      margin: 30/@w2;
      .radius(8/@w2);
      border-bottom: 1px solid #bdbdc5;
      font-size: 30/@w2;
      .vux-label-desc {
        margin-top: 10/@w2;
        color: #5d5d5d;
        font-size: 26/@w2;
      }
      line-height: 40/@w2;
    }
    .v-cell-box:before {
      display: none;
    }
    .v-mt {
      margin-top: -20/@w2;
      margin-bottom: 0;
      .weui_cell_primary {
        p {
          line-height: 1.3
        }
      }
    }
    .cell-no-before:before {
      display: none;
    }
    .cell-no-before .weui_cell_primary > p > div {
      margin-left: 16/@w2;
    }
    .group-no-before .weui_cells {
      line-height: 1.941176467733564;
    }
    .group-no-before .weui_cells:before {
      display: none;
    }
    .v-cell-common .vux-label-desc {
      color: #ce3b28;
    }
    .v-cell-common {
      border: none;
      .radius(16/@w2);
    }
    .fs40 {
      font-size: 40/@w2;
    }
    .text {
      padding: 0 30/@w2 30/@w2 30/@w2;
      color: #5d5d5d;
      font-size: 26/@w2;
    }
    .after-title {
      color: #9a9a9a;
      font-size: 26/@w2;
    }
    .cell-no-before button {
      background: #a7a7b1;
      color: #fff;
      border-radius: 50px 0 0 50px;
      height: 50/@w2;
      line-height: 50/@w2;
      right: 0;
      top: 50%;
      position: absolute;
      margin-top: -25/@w2 !important;
      font-size: 26/@w2;
      &:after {
        display: none;
      }
    }
    .cell-no-before {
      padding: 0 30/@w2;
      margin-top: 30/@w2;
      .fc-gray {
        color: #5d5d5d;
        font-size: 26/@w2;
      }
      .fc-red {
        color: #ce3b28;
        font-size: 26/@w2;
      }
    }

    .v-auction-disable .cell-no-before button {
      background: #a7a7b1;
    }
    .v-auction-disable .cell-no-before .fc-red {
      color: #ce3b28;
      font-size: 26/@w2;
    }
    .v-auction-working .cell-no-before button {
      background: #ff5a22;
    }
    .v-auction-success .cell-no-before button {
      background: #1aad19;
    }
    .auction-detail .weui_cell:before {
      display: none
    }
    .auction-detail .order-state .order-check li .info-label {
      width: 180/@w2;
    }
    .detail {
      color: #9a9a9a;
      line-height: 40/@w2;
      margin-bottom: 26/@w2;
      margin-left: 30/@w2;
      padding-right: 0.4rem;
    }
    .fc-blue {
      color: #6682ba;
    }
    .v-cell-common .end-time {
      font-size: 26/@w2;
      color: #5d5d5d
    }

  }

  // 加价幅度
  .price-increase {
    line-height:  48/@w2;
    margin-left: 19 / @w2;
    font-size: 26 / @w2;
    color: #ffffff;
    float: left;
  }
  // 加价幅度文字
  .price-increase-txt {
    height: 40 / @w2;
    line-height: 40 / @w2;
    background-color: #a7a7b1;
    padding: 0 32/@w2 0 20/@w2;

    border-top-left-radius:20/@w2;
    border-top-right-radius:20/@w2;
    border-bottom-right-radius:20/@w2
  }
</style>
